import { render, staticRenderFns } from "./FVideo.vue?vue&type=template&id=662996b9&scoped=true&"
import script from "./FVideo.vue?vue&type=script&lang=js&"
export * from "./FVideo.vue?vue&type=script&lang=js&"
import style0 from "./FVideo.vue?vue&type=style&index=0&id=662996b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662996b9",
  null
  
)

export default component.exports